import { X } from "lucide-react";
import FailedGIF from "../../assets/FailedGIF.gif";

type FailurePopupProps = {
  openFailurePopup: boolean;
  setOpenFailurePopup: (value: boolean) => void;
  handleClosePopup: () => void;
};

export default function FailurePopup({
  openFailurePopup,
  handleClosePopup,
}: FailurePopupProps) {
  return (
    <>
      {openFailurePopup && (
        <div className="fixed text-gray-700 inset-0 z-50 flex items-center justify-center bg-[#00000080]">
          <div className="relative bg-white m-4 flex flex-col justify-center rounded-[20px] shadow-lg w-full max-w-xl min-h-[350px] p-6">
            <button
              onClick={() => {
                handleClosePopup();
              }}
              className="absolute text top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X />
            </button>
            <div className="flex flex-col justify-center h-full items-center">
              <div className="w-40 h-40">
                <img
                  src={FailedGIF}
                  alt="Failed GIF"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-center mt-4">
                <h3 className="text-xl font-semibold text-red-600">Failed</h3>
                <p className="text-gray-600 mt-2">
                  Sorry, your payment was not successful. Please try again.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
